export const GL_ACCOUNT = "glMasterId";
export const PAYMENT_DATE_RANGE = "paymentDateRang";
export const POSTED_DATE_RANGE = "postedDateRang";
export const APPROVED_BY = "approvedBy";
export const POSTING_YEAR = "postingYear";
export const BUDGET_YEAR = "budgetYear";